export default "__VITE_ASSET__bcaa2025__"